import React, { Component } from "react";

class InputBox extends Component {
  constructor(props) {
    super(props);
    this.state = this.props.form_group;
  }

  inputChange(e) {
    let clone = { ...this.state };
    let new_clone = clone.textbox_list.map(textbox => {
      let field_name =
        "form[" + this.state.group_id + "]" + "[" + textbox.name + "]";
      if (field_name === e.target.name) {
        textbox.value = e.target.value;
      }
      return textbox;
    });

    this.setState(
      {
        new_clone
      },
      () => {
        this.props.inputboxChange(this.state);
      }
    );
  }

  inputbox_maker() {
    return this.state.textbox_list.map((textbox, index) => {
      let field_name;
      let label;
      if (textbox.name == "pro") {
        field_name = "pro";
        label = `${textbox.label} (Buy Pro version for this)`;
      } else {
        field_name =
          "form[" + this.state.group_id + "]" + "[" + textbox.name + "]";
        label = textbox.label;
      }
      return (
        <div
          className={
            textbox.name === "pro"
              ? "is-pro col-12 col-sm-6 my-3"
              : "col-12 col-sm-6 my-3"
          }
          key={index}
        >
          {label}
          {textbox.desc !== undefined && textbox.desc !== "" ? (
            <img
              src={window.css_js_manager.tip}
              className="ml-2 pi-icon"
              title={textbox.desc}
              alt=""
            />
          ) : (
            ""
          )}
          <input
            type="text"
            className="form-control mt-1"
            name={field_name}
            value={
              textbox.value == undefined || textbox.value === ""
                ? ""
                : textbox.value
            }
            onChange={e => {
              this.inputChange(e);
            }}
            disabled={textbox.name === "pro" ? "disabled" : false}
          />
        </div>
      );
    });
  }

  render() {
    return (
      <div className="card text-dark bg-light mb-3">
        <div className="card-header">
          <h4>{this.props.form_group.title}</h4>
        </div>
        <div className="card-body">
          <div className="row">{this.inputbox_maker()}</div>
        </div>
      </div>
    );
  }
}

export default InputBox;
